import request from "@/utils/request";

export const quantityStatistic = (params) =>
  request({
    url: "/api/backend/data/statistics",
    method: "GET",
    params,
  });

export const productRanking = (params) =>
  request({
    url: "/api/backend/data/commodity",
    method: "GET",
    params,
  });

export const merchantRanking = (params) =>
  request({
    url: "/api/backend/data/store",
    method: "GET",
    params,
  });

export const briefing = (params) =>
  request({
    url: "/api/backend/data/index",
    method: "GET",
    params,
  });

export const trend = (params) =>
  request({
    url: "/api/backend/data/trend",
    method: "GET",
    params,
  });

export const platformStatistic = (params) =>
  request({
    url: "/api/backend/data/channels",
    method: "GET",
    params,
  });

export const topFive = (params) =>
  request({
    url: "/api/backend/data/UserTop",
    method: "GET",
    params,
  });

export const testing = (params) =>
  request({
    url: "/api/backend/data/recommend/people_num",
    method: "GET",
    params,
  });

export const pointDetail = (params) =>
  request({
    url: "/api/backend/data/integral",
    method: "GET",
    params,
  });
export const subordinate = (params) =>
  request({
    url: "/api/backend/data/subordinate",
    method: "GET",
    params,
  });
export const subordinateList = (params) =>
  request({
    url: "/api/backend/data/subordinate/list",
    method: "GET",
    params,
  });
export const channelList = (params) =>
  request({
    url: "/api/backend/data/parent/channel/list",
    method: "GET",
    params,
  });
